module.exports = __webpack_public_path__ + "static/media/audio.e41f4c87.svg";